import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getCategoryTranlation (callback) {
    HTTP.get('category/translations').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getCategories (callback) {
    HTTP.get('category').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getCategoryById (callback, param) {
    if (param !== undefined) {
      HTTP.get('category/' + param).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getCategoryParent (callback, categoryId) {
    if (categoryId !== undefined) {
      HTTP.get('category/' + categoryId + '/parents').then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getCategoryChild (callback, categoryId) {
    if (categoryId !== undefined) {
      HTTP.get('category/' + categoryId + '/childs').then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  addCategory (callback, param) {
    HTTP.post('category', param).then(response => {
      if (response.status === 201) {
        callback(response)
      }
    }).catch(e => {
      if (e.response.status === 401) {
        HttpFunctions.response401()
      } else if (e.response.status === 403) {
        console.log('Error: pdo error message')
      } else if (e.response.status === 400) {
        callback(e.response)
      }
    })
  },
  updateCategory (callback, param) {
    HTTP.put('category', param).then(response => {
      if (response.status === 201) {
        callback(response)
      }
    }).catch(e => {
      if (e.response.status === 401) {
        HttpFunctions.response401()
      } else if (e.response.status === 403) {
        console.log('Error: pdo error message')
      } else if (e.response.status === 400) {
        callback(e.response)
      }
    })
  },
  deleteCategory (callback, params) {
    HTTP.delete('category', {data: {id: params}}).then(response => {
      if (response.status === 200) {
        callback(response)
      }
    }).catch(e => {
      if (e.response.status === 400) {
        callback(e.response)
      } else if (e.response.status === 401) {
        HttpFunctions.response401()
      } else if (e.response.status === 403) {
        console.log('Error: pdo error message')
      }
    })
  },
  checkCategoryStaticUrl (callback, body) {
    if (body !== undefined) {
      HTTP.get('category/static_url/' + body).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getVelaeasySections (callback, categoryId) {
    if (categoryId !== undefined) {
      HTTP.get('category/velaeasy_sections/' + categoryId).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getCategorySortingOptions (categoryId, callback) {
    HTTP.get('category/sort/option?category_id=' + categoryId).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: required data is missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getCategoriesSortList (categoryId, callback) {
    HTTP.get('category/sort/list?category_id=' + categoryId).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: required data is missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getCategorySortListById (params, callback) {
    HTTP.get('category/sort/id/list?category_id=' + params.category_id + '&sort_id=' + params.sort_id).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: required data is missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  updateCategoriesSortList (params, callback) {
    HTTP.put('category/sort/list', params).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: required data is missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  updateCategoriesSorting (params, callback) {
    HTTP.put('category/sort', params).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: required data is missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getDefaultSortOptionsSetting (callback) {
    HTTP.get('category/sort/option/default').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: required data is missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  insertDefaultCategorySorting (params, callback) {
    HTTP.post('category/sort/option/default', params).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: required data is missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/categories/index.js